import {useTranslation} from "react-i18next";
import {statisticsType} from "@ots-frontend/ots-data";
import {useMemo} from "react";
import {ByInsight, ByInsightProps} from "../ByInsight/ByInsight";

export type RejectsByInsightProps = Omit<ByInsightProps, 'statisticsType' | 'title'> & {
  title?: string
}

export const RejectsByInsight = (props: RejectsByInsightProps) => {
  const {title, ...rest} = props

  const {t} = useTranslation()

  const insightTitle = useMemo(() => {
    return title ?? t("common.insight.rejectsby", "Rejects By")
  }, [title, t])

  return (
    <ByInsight
      {...rest}
      title={insightTitle}
      statisticsType={statisticsType.rejects}/>
  )
}
